export default {
  trainingCourseDetail_image_text: '圖文',
  trainingCourseDetail_blend: '混合',
  trainingCourseDetail_games: '遊戲',
  trainingCourseDetail_vedio: '視頻',
  trainingCourseDetail_audio: '音頻',
  trainingCourseDetail_e_books: '電子書',
  trainingCourseDetail_not_completed: '暫未完成本課件的全部打卡驗證',
  trainingCourseDetail_continue_punch: '請繼續學習完成打卡',
  trainingCourseDetail_clock_progress: '打卡進度',
  trainingCourseDetail_continue_learn: '繼續學習',
  trainingCourseDetail_learned_rules01: '已學條件：學習完整內容並超過{ruleValue}分鐘',
  trainingCourseDetail_learned_rules02: '註：含考試的課件，未學滿{ruleValue}分鐘，考試通過也無法標記已學，需學滿{ruleValue}分鐘後再重新考試。',
  trainingCourseDetail_exit_Course: '退出學習',
  trainingCourseDetail_book_title_mark1: '《',
  trainingCourseDetail_book_title_mark2: '》',
  trainingCourseDetail_Learn_now: '立即學習',
  trainingCourseDetail_Learn_precess: "已學習{processValue}%",
}
